module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10057.97234d4b.jpg";